<div class="content">
  <md-card class="program-article">    
    <app-program-article-dashboard></app-program-article-dashboard>
    <!-- <app-translations-dashboard></app-translations-dashboard> -->
  </md-card>
  <md-card class="translate">
      <app-translations-dashboard [displayInTranslationPage]="false"></app-translations-dashboard>
  </md-card>
</div>


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/dashboard.component.html